import { z } from "zod";

// ==========================================
// #region RESÍDUOS
// ==========================================

export const ControleResiduoSchema = z.object({
  idControleResiduos: z.number().nullish(),
  idObra: z.number().nullish(),
  ano: z.coerce.number().nullish(),
  idDescricaoMes: z.number().nullish(),
  volumeM3: z.coerce.number().nullish(),
  valorCacamba: z.coerce.number().nullish(),
  qtdeTotal: z.coerce.number().nullish(),
  volumeTotal: z.coerce.number().nullish(),
  valorTotal: z.coerce.number().nullish(),
  efetivoMes: z.coerce.number().nullish(),
  mediaTrabalhador: z.coerce.number().nullish(),
  areaConstruida: z.coerce.number().nullish(),
  mediaArea: z.coerce.number().nullish(),
  metaAprovacao: z.coerce.number().nullish(),
  observacao: z.string().nullish(),

  nomeArquivo1: z.string().nullish(),
  arquivo1: z.instanceof(File).nullable(),

  limparArquivo1: z.coerce.boolean().default(false),
});

export type ControleResiduoForm = z.infer<typeof ControleResiduoSchema>;

// #endregion
